"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimSpacesAndDots = exports.getSupportedFilesFromAcceptProp = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const trimSpacesAndDots = string => _lodash.default.trim(string, '\x20.');
exports.trimSpacesAndDots = trimSpacesAndDots;
const getSupportedFilesFromAcceptProp = accept => _lodash.default.chain(accept).split(',').map(fileType => {
  const MIMEType = _lodash.default.words(fileType, /(.*)\/(.*)/i);
  const type = MIMEType[1];
  const subtype = MIMEType[2];
  if (!MIMEType.length) return trimSpacesAndDots(fileType);
  if (subtype && subtype !== '*') return subtype;
  return trimSpacesAndDots(type);
}).join(', ').value();
exports.getSupportedFilesFromAcceptProp = getSupportedFilesFromAcceptProp;